class TestingNotesFaq extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.items = this.querySelectorAll('.testing-notes-faq-item');
  
      if (!this.items.length) return;
  
      // First item open by default
      this.openItem(this.items[0]);
  
      this.items.forEach((item) => {
        const header = item.querySelector('.testing-notes-faq-item-header');
  
        header.addEventListener('click', () => {
          const isActive = item.classList.contains('active');

          // Close current active item
          const activeItem = this.querySelector(
            '.testing-notes-faq-item.active'
          );

          if (activeItem) {
            this.closeItem(activeItem);
          }

          // If the clicked item wasn't already active, open it
          if (!isActive) {
            this.openItem(item);
          }
        });
      });
    }
  
    openItem(item) {
      const content = item.querySelector(
        '.testing-notes-faq-item-content'
      );
  
      item.classList.add('active');
  
      content.style.display = 'block';
      content.style.height = '0px';
      content.style.overflow = 'hidden';
  
      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + 'px';
      });
  
      const transitionEnd = () => {
        content.style.height = 'auto';
        content.removeEventListener('transitionend', transitionEnd);
      };
  
      content.addEventListener('transitionend', transitionEnd);
    }
  
    closeItem(item) {
      const content = item.querySelector(
        '.testing-notes-faq-item-content'
      );
  
      content.style.height = content.scrollHeight + 'px';
  
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
  
      item.classList.remove('active');
    }
  }
  
  customElements.define('testing-notes-faq', TestingNotesFaq);